import React, { HTMLAttributes, forwardRef } from "react";

export type HeadingProps = HTMLAttributes<HTMLHeadingElement> & {
  headingType: "sectionHeading" | "resourceTitle";
};

const Heading = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ headingType, children, ...rest }, ref) => {
    return headingType === "resourceTitle" ? (
      <h3 ref={ref} {...rest}>
        {children}
      </h3>
    ) : (
      <h2 ref={ref} {...rest}>
        {children}
      </h2>
    );
  }
);

export default Heading;
